import * as React from 'react';
import 'react/jsx-runtime';

function t(){let e=false;return {clearReset:()=>{e=false;},reset:()=>{e=true;},isReset:()=>e}}var s=React.createContext(t()),o=()=>React.useContext(s);

export { o as useQueryErrorResetBoundary };
//# sourceMappingURL=contact-channels113.js.map
